import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
} from "@mui/material";
import { AiOutlineClose } from "react-icons/ai";
const ExplanationModal = ({ isOpen, onClose, onSave, initialValue }) => {
  const [value, setValue] = useState("");
  useEffect(() => {
    setValue(initialValue || "");
  }, [initialValue]);
  const handleSave = () => {
    onSave(value);
    onClose();
  };
  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle
        sx={{
          fontWeight: 700,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        Edit Flow Explanation
        <IconButton onClick={onClose}>
          <AiOutlineClose />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ bgcolor: "#F9FAFB" }}>
        <TextField
          label="Flow Explanation"
          multiline
          rows={5}
          fullWidth
          value={value}
          onChange={(e) => setValue(e.target.value)}
          size="small"
        />
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="contained"
          sx={{
            bgcolor: "#25D366",
            textTransform: "none",
            "&:hover": { bgcolor: "#22C35E" },
          }}
          onClick={handleSave}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default ExplanationModal;